"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LeaveFullScreen = void 0;
var react_1 = __importDefault(require("react"));
var LeaveFullScreen = function (_a) {
  var className = _a.className;
  return react_1.default.createElement("svg", {
    className: className,
    width: "16",
    height: "16",
    viewBox: "0 0 48 48"
  }, react_1.default.createElement("g", null, react_1.default.createElement("polygon", {
    points: "17,0 17,17 0,17 0,10 10,10 10,0 \t"
  })), react_1.default.createElement("g", null, react_1.default.createElement("polygon", {
    points: "0,31 17,31 17,48 10,48 10,38 0,38 \t"
  })), react_1.default.createElement("g", null, react_1.default.createElement("polygon", {
    points: "31,0 31,17 48,17 48,10 38,10 38,0 \t"
  })), react_1.default.createElement("g", null, react_1.default.createElement("polygon", {
    points: "48,31 31,31 31,48 38,48 38,38 48,38 \t"
  })));
};
exports.LeaveFullScreen = LeaveFullScreen;